module.exports = __webpack_public_path__ + "media/white-label/state-d228e3a4.png";